import Message from "@components/Message";

import i18next from "@/lib/intl/i18next";
import { type VerificationService } from "@/lib/types/types";

interface ExtraMessageProps {
  verificationService?: VerificationService;
  suffix: "CollectAboveSubmit"; // In the future, expand this type for other official extra messages. e.g. add "| 'CollectBelowSubmit'"
}
/**
 * Defines the expected literal union type for message IDs generated from ExtraMessageProps.suffix.
 * TODO: Refactor theme specific messages into an interface for easier Declaration Merging of keys
 *   but for now this is exported in the @/lib/intl/type space for redist.
 */
export type ExtraMessageId = `extraMessage${ExtraMessageProps["suffix"]}`;
/**
 * Extra message component
 *
 * Easily register extra messages to specific spots in the form using this component
 *
 * These new regions do NOT have a message by default, but messages can be added simply by specifying the messageId + value
 * either in my.sheerid.com or via setOptions(). No need to override a component just to add a message as long as the ExtraMessage
 * appears in a desirable spot.
 */
export const ExtraMessage = ({ suffix }: ExtraMessageProps) => {
  const messageId: ExtraMessageId = `extraMessage${suffix}`;
  // if there is no i18next message for and id of `messageId` return null;
  if (!i18next.exists(messageId)) {
    return null;
  }

  return (
    <div className={`sid-extra-message sid-extra-message-${suffix}`}>
      <div className="sid-l-space-top-md" />
      <Message id={messageId} />
    </div>
  );
};
